import React from "react";
import { MessageCircle, Play, Check, Sparkles } from "lucide-react";
import { waHref } from "./utils";

export default function Hero() {
  return (
    <section id="top" className="pt-24 pb-16 stadium-bg relative overflow-hidden">
      <div className="max-w-6xl mx-auto px-6 grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
        <div>
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-blue-600/15 border border-blue-800 text-blue-300 text-xs font-semibold uppercase tracking-wider mb-6">
            <Sparkles size={12} /> Built for cricket broadcasters
          </div>
          <h1 className="font-heading text-5xl md:text-6xl font-black uppercase leading-[1.05] tracking-tight">
            Broadcast cricket
            <br /><span className="text-blue-500">like a pro.</span>
          </h1>
          <p className="mt-5 text-lg text-slate-300 max-w-lg leading-relaxed">
            Live scorebug, batting cards, bowling cards and match summary — <b>updating in real-time</b> as you score.
            Paste one URL into vMix or OBS and your YouTube stream instantly looks like ESPN.
          </p>
          <div className="mt-8 flex flex-wrap gap-3">
            <a href={waHref("Hi! I want to start with Cricket Graphics Studio. Please share the next steps.")}
              target="_blank" rel="noreferrer" data-testid="hero-wa-cta"
              className="inline-flex items-center gap-2 px-6 py-3.5 rounded-lg bg-emerald-600 hover:bg-emerald-700 font-bold text-lg shadow-lg shadow-emerald-900/50">
              <MessageCircle size={18} /> Start on WhatsApp
            </a>
            <a href="#video" data-testid="hero-watch-cta"
              className="inline-flex items-center gap-2 px-6 py-3.5 rounded-lg bg-slate-800 hover:bg-slate-700 border border-slate-700 font-semibold">
              <Play size={16} /> Watch 5-min walkthrough
            </a>
          </div>
          <div className="mt-8 flex items-center gap-6 text-sm text-slate-400">
            <div className="flex items-center gap-2"><Check size={14} className="text-emerald-500" /> Zero install</div>
            <div className="flex items-center gap-2"><Check size={14} className="text-emerald-500" /> vMix + OBS ready</div>
            <div className="flex items-center gap-2"><Check size={14} className="text-emerald-500" /> Live in 30 min</div>
          </div>
        </div>

        <MockScorebugPreview />
      </div>
    </section>
  );
}

function MockScorebugPreview() {
  return (
    <div className="relative">
      <div className="rounded-2xl border border-slate-700 overflow-hidden shadow-2xl">
        <div className="aspect-video bg-gradient-to-br from-emerald-900 via-slate-900 to-slate-950 relative">
          <div className="absolute inset-0 flex items-center justify-center text-slate-600 text-sm">
            YouTube Live Broadcast Preview
          </div>
          <div className="absolute bottom-4 left-1/2 -translate-x-1/2 w-[92%]">
            <div className="flex items-stretch bg-slate-900 rounded-lg overflow-hidden shadow-2xl">
              <div className="flex items-center gap-2 px-3 py-2 bg-blue-900 text-white flex-1">
                <div className="w-7 h-7 rounded-full bg-white/25" />
                <div className="font-heading font-black">IND</div>
                <div className="ml-auto text-xs opacity-90"><b>V Kohli</b> 56*(38)</div>
              </div>
              <div className="bg-white text-slate-900 px-3 py-2 flex flex-col items-center min-w-[80px]">
                <div className="font-heading font-black text-lg leading-none">187-5</div>
                <div className="text-[10px] opacity-70">OVERS 15.4</div>
              </div>
              <div className="flex items-center gap-2 px-3 py-2 bg-emerald-900 text-white flex-1">
                <div className="ml-auto text-xs opacity-90"><b>M Rahman</b> 1-34</div>
                <div className="font-heading font-black">BAN</div>
                <div className="w-7 h-7 rounded-full bg-white/25" />
              </div>
            </div>
            <div className="mt-1 flex items-center justify-between text-[10px] bg-amber-500 text-slate-900 px-3 py-1 font-bold uppercase">
              <span>Current RR: 11.85</span>
              <span>IND need 43 in 26 balls</span>
              <span>Extras: 10</span>
            </div>
          </div>
        </div>
        <div className="bg-slate-900 border-t border-slate-800 p-3 text-xs text-slate-400 flex items-center gap-2">
          <div className="w-2 h-2 rounded-full bg-red-500 animate-pulse" /> LIVE on YouTube · Powered by Cricket Graphics Studio
        </div>
      </div>
    </div>
  );
}
